import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ICompanyDetailsViewModel } from "@pages/companies/models/company-profile-state.interface";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { AppCopyDirective } from "@shared/directives/copy.directive";
import { ACNPipe } from "@shared/pipes/acnPipe";
import { CompanySubtypePipe } from "@shared/pipes/companySpecialPurposeStatusPipe";
import { CompanyStatusPipe } from "@shared/pipes/companyStatusPipe";
import { CompanyTypePipe } from "@shared/pipes/companyTypePipe";
import { DateFormatPipe } from "@shared/pipes/dateFormatPipe";
import { DefaulValuePipe } from "@shared/pipes/defaultValuePipe";
import { JurisdictionPipe } from "@shared/pipes/jurisdictionPipe";
import { PhonePipe } from "@shared/pipes/phonePipe";

@Component({
  selector: 'app-company-details',
  standalone: true,
  templateUrl: 'company-details.component.html',
  styleUrl: 'company-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DividerComponent,
    AppCopyDirective,
    DefaulValuePipe,
    ACNPipe,
    CompanyTypePipe,
    CompanySubtypePipe,
    CompanyStatusPipe,
    DateFormatPipe,
    JurisdictionPipe,
    PhonePipe,
  ]
})
export class CompanyDetailsComponent {
  companyDetailsViewModel = input.required<ICompanyDetailsViewModel>();
}
